import { Note } from "common";
import { NoteBody } from "./NoteBody";
import { Link as ReactRouterLink } from "react-router-dom";
import { Text, Link } from "@chakra-ui/react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteAccountName } from "./useNoteAccountName";

interface NoteDeleteYouthKidBodyProps {
  note: Note;
}

export const NoteDeleteYouthKidBody = ({
  note,
}: NoteDeleteYouthKidBodyProps) => {
  const account = useNoteAccount(note);
  const accountName = useNoteAccountName(note);
  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        deleted youth kid "{note.message}"
      </Text>
    </NoteBody>
  );
};
